import { Component, OnInit } from '@angular/core';
import { AuthService } from './shared/services/auth.service';
import { lastValueFrom, Observable, of } from 'rxjs';
import * as LogRocket from 'logrocket';
import { environment } from '../environments/environment';
import { filter, map, take } from 'rxjs/operators';
import { VersioningService } from './shared/services/versioning.service';
import { IntercomService } from './shared/services/intercom.service';

@Component({
  selector: 'tb-root',
  templateUrl: './app.component.html',
  styleUrls: [],
})
export class AppComponent implements OnInit {
  public title = '5F Customer Portal';
  public isLoggedIn$: Observable<boolean>;

  constructor(
    private authService: AuthService,
    private _: VersioningService,
    private intercomService: IntercomService,
  ) {
    this.isLoggedIn$ = this.authService.isLoggedIn$;
  }

  public ngOnInit() {
    this.enableLogRocket();
  }

  private enableLogRocket() {
    if (window.location.hostname === 'localhost') {
      return;
    }
    const logRocketOptions = {
      release: '0.0.0',
    };

    if (environment.production) {
      LogRocket.init('stkslu/5f-customer-portal', logRocketOptions);
    } else {
      LogRocket.init('stkslu/5f-customer-portal-stage');
    }

    this.lgIdentify();
  }

  private async lgIdentify() {
    const user = await lastValueFrom(
      this.authService.userInfo$.pipe(
        filter((t) => !!t),
        take(1),
      ),
    );
    LogRocket.identify(user.userId, {
      name: user.userName,
      email: user.userEmail,
      accountName: user.BrokerAccountName,
      accountID: user.BrokerAccountId,
      accountType: user.type,
      isInternal: user.internal,
    });
  }
}
